import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { IUserProfileService } from '../entities/IUserProfileService';
import { IUserProfileRepository } from '../entities/IUserProfileRepository';

export class UserProfileServiceImpl implements IUserProfileService {
  itemRepo: IUserProfileRepository;

  constructor(ir: IUserProfileRepository) {
    this.itemRepo = ir;

    this.OTPAuthorizationPhone = this.OTPAuthorizationPhone.bind(this);
    this.UpdatePhone = this.UpdatePhone.bind(this);
    this.CreateEmailAuthorization = this.CreateEmailAuthorization.bind(this);
  }

  OTPAuthorizationPhone(data?: GenericObject): Promise<{}> {
    return this.itemRepo.OTPAuthorizationPhone(data);
  }

  UpdatePhone(data?: GenericObject): Promise<{}> {
    return this.itemRepo.UpdatePhone(data);
  }

  CreateEmailAuthorization(data: GenericObject): Promise<{}> {
    return this.itemRepo.CreateEmailAuthorization(data);
  }
}
